import React from 'react';

import { useProcessAsync } from '@gogame/hooks-ts';

import { LoaderContext } from './LoaderContext';

export default ({ children }) => {
  const [loading, processAsync] = useProcessAsync();
  return (
    <LoaderContext.Provider
      value={{
        loading,
        processAsync,
      }}
    >
      {children}
    </LoaderContext.Provider>
  );
};
